(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function init(scope = document) {
    scope.querySelectorAll('[data-premium-video]:not([data-ready])').forEach(root => {
      root.dataset.ready = 'true';
      const video = root.querySelector('video');
      const toggle = root.querySelector('[data-video-toggle]');
      if (!video || !toggle) return;
      const sync = () => {
        toggle.setAttribute('aria-label', video.paused ? toggle.dataset.play : toggle.dataset.pause);
        toggle.textContent = video.paused ? '▶' : 'Ⅱ';
        toggle.setAttribute('aria-pressed', String(!video.paused));
      };
      const play = () => { video.muted = true; video.play().catch(sync); };
      toggle.addEventListener('click', () => video.paused ? play() : video.pause());
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      if (reduced.matches) video.pause(); else play();
      sync();
    });
    scope.querySelectorAll('[data-finder]:not([data-ready])').forEach(root => {
      root.dataset.ready = 'true';
      root.addEventListener('change', () => {
        const selected = root.querySelector('input:checked');
        if (!selected) return;
        root.querySelectorAll('[data-finder-result]').forEach(panel => { panel.hidden = panel.dataset.finderResult !== selected.value; });
      });
    });
    scope.querySelectorAll('[data-ritual]:not([data-ready])').forEach(root => {
      root.dataset.ready = 'true';
      const panels = root.querySelectorAll('details');
      panels.forEach(item => item.addEventListener('toggle', () => {
        if (item.open) {
          panels.forEach(other => { if (other !== item) other.open = false; });
          root.querySelectorAll('[data-ritual-picture]').forEach(img => { img.hidden = img.dataset.ritualPicture !== item.dataset.step; });
        }
      }));
    });
    scope.querySelectorAll('[data-kit-dialog]:not([data-ready])').forEach(dialog => {
      dialog.dataset.ready = 'true';
      dialog.querySelector('[data-dialog-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
      document.querySelectorAll('[data-open-kit="' + dialog.id + '"]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => dialog.showModal());
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    const toggle = document.querySelector('[data-menu-toggle][aria-expanded="true"]');
    if (toggle) { toggle.click(); toggle.focus(); }
  });
})();
